import styled from "styled-components";

export const UserDeviceMappingManagementWrapper = styled.div`
    width: 100%;
    height: 100%;
    min-height: 600px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const UserDeviceMappingList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex: 1 1 auto;
`;

export const ToolBarWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0px;
    padding: 0px 20px;
`;

export const SearchInputWrapper = styled.div`
    width: 400px;
`;

export const TableWrapper = styled.div`
    flex: 1 1 auto;
`;

export const OperationWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 10px 0px;
`;
